<!-- src/views/HomePage.vue -->
<template>
  <div class="c-text-column" style="    position: relative;top: -90px;">
    <div class="c-text-between px-container c-flex-wrap" style="margin: 80px 0;">
      <div class="display-width c-text-column" style="align-items: flex-start; justify-content: center;">
        <span class="c-mb-10">开源资源</span>
      
        <div class="c-text-align">
          <h1 style="font-size: 40px;font-family: 'Montserrat', sans-serif;text-align: left;">FRANKA LABS</h1>
        </div>
        <span class="c-mt-10 c-mb-10 c-text-left text-indent">
          LABS（学习与行为获取套件）是一个开源的、基于微服务架构的机器人遥操作与数据采集解决方案。它围绕 Franka 参考配置进行设计，并凭借其模块化架构，可扩展至您基于 Franka 的工作单元，以及其他机器人和外围设备。
        </span>
        <div class="c-text-justify-start c-flex-wrap c-mt-10 c-mb-10">
            <a  class="buttonSite"
           href="https://github.com/frankarobotics/labs" target="_blank">访问 GitHub 了解更多</a>
        </div>
      </div>

      <div class="display-width c-text-align">
        <div style="aspect-ratio:  716/450;">
          <img src="@/assets/images/labs/data-collection-ui-preview.gif" style="width: 100%;aspect-ratio: 716/450;" />
        </div>
      </div>
    </div>

    <div style="background: #eff1f3;   padding-bottom: 5px;" class=" c-pdt-20">
      <div class="line-with-text px-container" id="system-image">
        <hr class="divider">
        <span class="line-text">关于 LABS</span>
        <hr class="divider">
      </div>

      <div class="c-text-between px-container c-flex-wrap " style="margin-bottom: 80px;gap: 40px;">
        <div class="display-width c-text-column ">
          <div class="c-text-justify-start">
            <h3 class="c-text-left c-mr-10">重点始终在于研究，而非集成工作</h3>
          </div>
          <span class="c-mt-5 c-mb-5 text-indent" style="text-align: left; ">
            研究人员应专注于遥操作、数据采集、训练、策略部署与基准测试。LABS 消除了这些环节中繁琐的集成工作，从而降低工程开销，加快研究迭代速度。
          </span>

        </div>
        <div class="display-width c-text-column ">
          <div class="c-text-justify-start">
            <h3 class="c-text-left c-mr-10">从数据采集到部署的一致工作流</h3>
          </div>
          <span class="c-mt-5 c-mb-5 text-indent" style="text-align: left; ">
           在整个流程中使用统一的驱动程序、控制器和接口，可确保数据采集、评估与部署之间的一致性，从而提高可复现性并减少重复工作。
          </span>
        </div>
        <div class="display-width c-text-column ">
           <div class="c-text-justify-start">
            <h3 class="c-text-left c-mr-10">即拿即用的参考配置</h3>
          </div>
          <span class="c-mt-5 c-mb-5 text-indent" style="text-align: left; ">
            LABS 为 FR3（Droid 配置）、FR3 Duo（双臂参考配置）以及 Mobile FR3 Duo（移动双臂参考配置）提供了参考实现。这些配置可以直接使用，也可以根据自定义的基于 Franka 的工作单元或研究环境进行调整。
          </span>
        </div>
        <div class="display-width c-text-column ">
           <div class="c-text-justify-start">
            <h3 class="c-text-left c-mr-10">模块化与可扩展架构</h3>
          </div>
          <span class="c-mt-5 c-mb-5 text-indent" style="text-align: left; ">
            所有组件均以独立的容器化服务运行，包括机器人驱动程序、遥操作设备、传感器、记录模块以及处理模块。无需更改核心技术栈，即可对系统进行扩展或修改。
          </span>
        </div>
      </div>
    </div>
    <div style="background: #eff1f3;margin-top: 80px;" class=" c-pdt-20">
      <div class="line-with-text px-container ">
        <hr class="divider">
        <span class="line-text">包含哪些内容
        </span>
        <hr class="divider">
      </div>
       <div class="c-text-between px-container c-flex-wrap " style="margin-bottom: 120px; ">
        <div class="display-width c-text-column c-mb-60  c-pdr-40"
          style="align-items: flex-start; justify-content: center;">
          <h3>三项流水线服务，统一技术栈</h3> 
          <span class="c-mt-20 c-mb-10 text-indent" style="text-align: left;">
           <div><strong>数据采集</strong></div> 
            基于 FastAPI 的编排服务，用于管理工作流状态机，通过网络界面实现对遥操作模式、任务选择以及试验生命周期控制的管理。
          </span>
          <span class="c-mt-5 c-mb-10 text-indent" style="text-align: left;">
            <div><strong>数据记录</strong></div> 
            基于 ROS 2 的记录服务，可采集来自所有活动设备（包括机器人、传感器和遥操作输入）的同步主题数据。数据以 MCAP 格式的试验文件存储。
          </span>
          <span class="c-mt-5 c-mb-10 text-indent" style="text-align: left;">
            <div><strong>数据处理</strong></div> 
            后处理服务，用于对记录的试验数据进行转换、应用视频编码，并将数据集导出为 LeRobot v2.1 格式，供下游训练工作流使用。
          </span>
        </div>
        <div class="display-width c-text-align">
            <div style="aspect-ratio:  716/450;">
            <img src="@/assets/images/labs/_Frank Robotics0363 (1)-1.jpg" style="width: 100%;aspect-ratio: 716/450;" />
            </div>
        </div>
      </div>
    </div>
      <div class="c-text-between px-container c-flex-wrap" style="margin: 80px 0;">
      <div class="display-width c-text-column" style="align-items: flex-start; justify-content: center;">
        <div class="c-text-align">
          <h1 style="font-size: 40px;font-family: 'Montserrat', sans-serif;text-align: left;">从硬件设置到数据集的五步流程</h1>
        </div>
        <span class="c-mt-10 c-mb-10 c-text-left text-indent">
           LABS 旨在最大限度地缩短从硬件搭建到首次录制试验之间的时间。
        </span>
        <div class="c-text-justify-start c-flex-wrap c-mt-10 c-mb-10">
          <!-- <router-link to="/contact" class="buttonSite  c-mr-20">访问 GitHub 了解更多</router-link> -->
            <a  class="buttonSite" style="width: 200px;"
           href="https://github.com/frankarobotics/labs" target="_blank">访问GitHub上的项目页面</a>
        </div>
      </div>
      <div class="display-width c-text-align">
        <div style="aspect-ratio:  716/450;">
          <img src="@/assets/images/labs/LABS.png" style="width: 100%;aspect-ratio: 716/450;" />
        </div>
      </div>
    </div>
     <div class="c-text-between px-container c-flex-wrap " style="margin-bottom: 80px;gap: 40px;">
        <div class="display-width c-text-column ">
          <div class="c-text-justify-start">
            <h3 class="c-text-left c-mr-10"> 1.配置您的工作站</h3>
          </div>
          <span class="c-mt-5 c-mb-5 text-indent" style="text-align: left; ">
            在部署配置文件中定义您的硬件设置，包括机器人 IP 地址、传感器类型及设备映射。
          </span>

        </div>
        <div class="display-width c-text-column ">
          <div class="c-text-justify-start">
            <h3 class="c-text-left c-mr-10">3.采集示范数据</h3>
          </div>
          <span class="c-mt-5 c-mb-5 text-indent" style="text-align: left; ">
           打开数据采集界面，选择任务，开始遥操作，并录制试验数据。
          </span>
        </div>
        <div class="display-width c-text-column ">
           <div class="c-text-justify-start">
            <h3 class="c-text-left c-mr-10">2.启动软件栈</h3>
          </div>
          <span class="c-mt-5 c-mb-5 text-indent" style="text-align: left; ">
            使用 Docker Compose 和 Tilt 部署系统。该软件栈以一组容器化微服务的形式运行，并通过实时开发环境进行管理。
          </span>
        </div>
        <div class="display-width c-text-column ">
           <div class="c-text-justify-start">
            <h3 class="c-text-left c-mr-10">4.记录并存储数据</h3>
          </div>
          <span class="c-mt-5 c-mb-5 text-indent" style="text-align: left; ">
            试验数据会自动以 MCAP 格式记录并存储，同时包含同步的传感器数据流与机器人数据流。
          </span>
        </div>
        
      <div class="display-width c-text-align">
        <div style="aspect-ratio:  716/450;">
          <img src="@/assets/images/labs/Screenshot 2026-06-01 at 17.31.32.png" style="width: 100%;aspect-ratio: 716/450;" />
        </div>
      </div>
        <div class="display-width c-text-column ">
           <div class="c-text-justify-start">
            <h3 class="c-text-left c-mr-10">5. 导出数据集</h3>
          </div>
          <span class="c-mt-5 c-mb-5 text-indent" style="text-align: left; ">
            运行数据处理程序，将录制的试验数据转换为结构化的 LeRobot v2.1 格式数据集。
          </span>
        </div>
      </div>
    <div class="line-with-text px-container">
      <hr class="divider">
      <span class="line-text">原型产品</span>
      <hr class="divider">
    </div>
    <div class="c-text-between px-container c-flex-wrap " style="margin-bottom: 80px;">
      <div class="display-width c-text-column  c-pdr-40" style="align-items: flex-start; justify-content: center;">
        <h1 class="c-text-left">物理 AI 的参考平台</h1>

        <span class="c-mt-5 c-mb-5 text-indent" style="text-align: left; ">
         新一代机器人系统，旨在赋能物理智能研究——从触觉遥操作到移动操作。这些系统支持物理 AI 相关活动，包括大规模数据采集和真实环境中的学习。
        </span>
        <!-- <a  class="buttonSite"
           href="https://github.com/frankarobotics/labs" target="_blank">探索新功能</a> -->
        <a class="buttonSite" @click="$router.push('/product-prototypes')">探索新功能</a>
           <!-- /product-prototypes -->

      </div>
      <div class="display-width c-text-both" style="aspect-ratio: 716/450;">
        <img src="@/assets/images/labs/260218_Camera01_fp (1)_resized.png" style=" height: 100%; max-width: 100%;" />
      </div>
    </div>
    <div id="product-add-ons"></div>
    <div class="line-with-text px-container">
      <hr class="divider">
      <span class="line-text">开发</span>
      <hr class="divider">
    </div>
    <div class="c-text-between px-container c-flex-wrap">
      <div class="display-width">
        <img src="@/assets/images/productsPage/Franka_Robotics.jpg" alt="" style="    height: auto; max-width: 100%;">
      </div>

      <div class="display-width c-text-column  c-pdr-40" style="align-items: flex-start; justify-content: center;">
        <span class="c-mb-10">构建、创造、创新</span>
        <h1>在 Franka 机器人平台上开发 </h1>

        <span class="c-mt-5 c-mb-10 text-indent" style="text-align: left;">Franka Research 3的机器人系统包括机械臂及其控制箱。
          面向 Franka Research 3 机器人平台开发者的资源中心。深入了解丰富的工具、库和文档，助力加速您的开发之旅。无论您是经验丰富的开发者，还是刚刚起步，都能在这里找到构建、创造和创新所需的一切。</span>
        <div class="c-text-justify-start c-flex-wrap c-mt-10 c-mb-10">
          <div class="buttonSite">
            <!-- documents -->
            <!-- <a href="/#/resources" target="_blank">获取资料</a> -->
            <a href="/#/develop" target="_blank">了解更多</a>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="c-text-column c-text-both action-height px-container" 
            style="align-items: flex-start; justify-content: center;">
            <h2 class="c-zIndex-2">对我们的产品感兴趣吗？</h2>
            <div class="c-text-justify-start c-flex-wrap c-mt-10 c-mb-10 c-zIndex-2"> 
                  <router-link to="/contact" class="buttonSite">联系我们</router-link> 
            </div>
            <div style="position: absolute;right: 0;height: 100%;"> 
              <img src="@/assets/images/productsPage/FR3 move new 6.png" alt=""
              style="    height: 100%; max-width: 100%;">
            </div> 
        </div> -->

  </div>
</template>

<script>

import backgroundImage from "@/assets/images/productsPage/FR3 move new 6.png";
export default {
  metaInfo() {
    return {
      title: this.$route.meta.title, // 从路由获取标题
      meta: [
        {
          name: 'keywords',
          content: this.$route.meta.metaTags[0]['content']
        }
      ]
    }
  },
  name: 'HomePage',
  data() {
    return {
      activeIndex: 0,
      carouselInterval: null,
      isTransitioning: false,
      images: [
        { src: require('@/assets/images/productsPage/Screenshot 2026-04-09 at 14.27.36 (1).png'), alt: 'Franka Robotics产品图片1' },
        { src: require('@/assets/images/productsPage/Screenshot 2026-04-09 at 14.24.05.png'), alt: 'Franka Robotics产品图片2' },
        { src: require('@/assets/images/productsPage/Screenshot 2026-04-09 at 14.21.11.png'), alt: 'Franka Robotics产品图片3' },
        { src: require('@/assets/images/productsPage/Screenshot 2026-04-09 at 14.25.59.png'), alt: 'Franka Robotics产品图片4' },
        { src: require('@/assets/images/productsPage/260217_MFR3_Duo_Camera18_03_fp_resized.png'), alt: 'Franka Robotics产品图片5' },
         
      ],
      iframe1: '2',
      iframe2: '2',
      backgroundImage: backgroundImage,
      tableData: [
        { name: '基于工作流的应用程序编程', DESK: true, RIDE: false, FCI: false },
        { name: '快速原型设计实验和演示 ', DESK: true, RIDE: false, FCI: false },
        { name: '执行机器人任务', DESK: true, RIDE: false, FCI: true },
        { name: '开发自定义应用程序', DESK: false, RIDE: true, FCI: false },
        { name: '连接第三方硬件', DESK: false, RIDE: true, FCI: true },
        { name: '连接外部资源', DESK: false, RIDE: true, FCI: true },
        { name: '1 kHz 力矩、位置和速度控制 ', DESK: false, RIDE: false, FCI: true },
        { name: '1 kHz 传感器信号和机器人状态的测量', DESK: false, RIDE: false, FCI: true },
        { name: '访问机器人运动学和动力学模型', DESK: false, RIDE: false, FCI: true },
        { name: '与ROS和MATLAB & Simulink的集成', DESK: false, RIDE: false, FCI: true },
      ]
    }

  },
  mounted() {
  },
  beforeUnmount() {
    // clearInterval(this.carouselInterval);
  },
  methods: {
  }
};
</script>
<style scoped>
.newBack:hover {
  background-color: #1b2f36;
  color: white;
}

.desktop-image {
  display: block;
  width: 100%;
}

.mobile-image {
  display: none;
  width: 100%;
}

@media (max-width: 999px) {
  .desktop-image {
    display: none;
  }
  .mobile-image {
    display: block;
  }
}

/* 新增轮播图样式 - 水平滑动效果 */
.carousel-container {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.carousel {
  position: relative;
  width: 100%;
  height: 100%;
}

.slides-wrapper {
  display: flex;
  height: 100%;
  transition: transform 0.5s ease;
  will-change: transform;
}

.slide {
  flex: 0 0 100%;
  min-width: 100%;
  position: relative;
}

.carousel-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.carousel-btn {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 40px;
  height: 40px;
  background: rgba(0, 0, 0, 0);
  color: white;
  border: none;
  border-radius: 50%;
  font-size: 20px;
  cursor: pointer;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.3s ease;
}

.carousel-btn:hover {
  /* background: rgba(0,0,0,0.8); */
}

.carousel-btn.prev {
  left: 15px;
}

.carousel-btn.next {
  right: 15px;
}

.carousel-indicators {
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 10px;
  z-index: 10;
}

.carousel-indicators span {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.5);
  cursor: pointer;
  transition: background 0.3s ease;
}

.carousel-indicators span.active {
  background: white;
}

li::marker {
  unicode-bidi: isolate;
  font-variant-numeric: tabular-nums;
  text-transform: none;
  text-indent: 0px !important;
  text-align: start !important;
  text-align-last: start !important;
}

.flex-width {
  width: calc(100% / 7);
}

@media (max-width: 1260px) {
  .flex-width {
    width: calc(100% / 4);
  }
}

@media (max-width: 999px) {
  .flex-width {
    width: calc(100% / 3);
  }
}

@media (max-width: 747px) {
  .flex-width {
    width: calc(100% / 2);
  }
}

@media (max-width: 150px) {
  .flex-width {
    width: 100%
  }
}

.title-width {
  width: 33.33%;
}

/* 屏幕宽度小于 900px 时，一行展示 2 个 */
@media (max-width: 899px) {
  .title-width {
    width: 100%
  }
}

.action-height {
  height: 400px;
  background-color: #d5dbdc;
  position: relative;
}

.action-width {
  width: calc(33% - 40px);
}

/* 屏幕宽度小于 900px 时，一行展示 2 个 */
@media (max-width: 1029px) {
  .action-width {
    width: calc(50% - 40px);
  }

  .action-height {
    height: 200px;
    background-color: #d5dbdc;
  }
}

/* 屏幕宽度小于 600px 时，一行展示 1 个 */
@media (max-width: 599px) {
  .action-width {
    width: 100%;
  }
}

table {
  width: 100%;
  border-collapse: collapse;
}

th,
td {
  border: 1px solid black;
  padding: 5px;
  text-align: left;
}
</style>